import React from 'react';
import styled from 'styled-components';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--cyan);
    font-family: var(--font-mono);
    font-size: 16px;
    font-weight: 400;
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    display: inline-block;
    margin-top: 50px;
    padding: 1.25rem 1.75rem;
    border: 1px solid var(--cyan);
    border-radius: 4px;
    color: var(--cyan);
    font-family: var(--font-mono);
    font-size: 14px;
    text-decoration: none;
    transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    &:hover {
      background-color: rgba(100, 255, 218, 0.1);
    }
  }
`;

const Contact = () => (
  <StyledContactSection id="contact">
    <span className="overline">What’s Next?</span>
    <h2 className="title">Get In Touch</h2>
    <p>
      Whether you have a question or just want to say hi, we’d love to hear from you. Our team is ready to help you with your AI needs.
    </p>
    <a className="email-link" href="mailto:info@jdlumen.ai">
      Say Hello
    </a>
  </StyledContactSection>
);

export default Contact;